/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecurringCostItemDto
 */
export interface RecurringCostItemDto {
    /**
     * 
     * @type {string}
     * @memberof RecurringCostItemDto
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof RecurringCostItemDto
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RecurringCostItemDto
     */
    frequency: string;
    /**
     * 
     * @type {string}
     * @memberof RecurringCostItemDto
     */
    type: string;
}

/**
 * Check if a given object implements the RecurringCostItemDto interface.
 */
export function instanceOfRecurringCostItemDto(value: object): value is RecurringCostItemDto {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('frequency' in value) || value['frequency'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function RecurringCostItemDtoFromJSON(json: any): RecurringCostItemDto {
    return RecurringCostItemDtoFromJSONTyped(json, false);
}

export function RecurringCostItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecurringCostItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'value': json['value'] == null ? undefined : json['value'],
        'frequency': json['frequency'],
        'type': json['type'],
    };
}

export function RecurringCostItemDtoToJSON(json: any): RecurringCostItemDto {
    return RecurringCostItemDtoToJSONTyped(json, false);
}

export function RecurringCostItemDtoToJSONTyped(value?: RecurringCostItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'value': value['value'],
        'frequency': value['frequency'],
        'type': value['type'],
    };
}

